import React, { FC, memo, useCallback, useMemo } from 'react';
import { deleteProject } from '../../../api/fetch-functions/project';
import { viewTexts } from '../../../constants/view-texts';
import { useToken } from '../../../global-state/auth-state';
import { fetchProjectListOf } from '../../../global-state/database/project-list';
import { IProjectType } from '../../../types/record/project';
import { ConfirmDeleteDialogTemplate } from '../confirm-delete-dialog-template/confirm-delete-dialog-template';

const vt = viewTexts.dialogs.deleteProject;

interface Props {
  open: boolean;
  onClose: (reason: 'ok' | 'cancel' | '') => void;
  project: IProjectType;
  companyId: number;
}

export const DeleteProjectDialog: FC<Props> = memo(
  ({ open, onClose, project: projectInit, companyId }: Readonly<Props>) => {
    const message = useMemo<string[]>(() => vt.message(projectInit.name), [
      projectInit.name
    ]);

    /* event handler */

    const token = useToken();

    const closeOnClick = useCallback(
      (reason: 'yes' | 'no') => {
        if (reason === 'no') {
          onClose('cancel');
        } else {
          if (token !== undefined && projectInit.name !== undefined) {
            deleteProject(token)(projectInit.id).then(res => {
              if (res.type === 'success') {
                onClose('ok');
                fetchProjectListOf(companyId);
              }
            });
          }
        }
      },
      [onClose, projectInit, companyId, token]
    );

    return (
      // TODO: 待機状態のUIを作る
      <ConfirmDeleteDialogTemplate
        title={vt.title}
        messages={message}
        open={open}
        onClose={closeOnClick}
      />
    );
  }
);

DeleteProjectDialog.displayName = 'DeleteProjectDialog';
